module.exports = __webpack_public_path__ + "img/sw.5ff4c6b8.png";